import React from 'react';

function Portfolio() {
  return (
    <section className="section">
      <div className="container">
        <h2 className="title">My Quests</h2>
        <div className="columns is-multiline">
          <div className="column is-one-third">
            <div className="card">
              <div className="card-content">
                <p className="title is-5">Project 1</p>
                <p className="subtitle is-6">Description of the project.</p>
              </div>
            </div>
          </div>
          <div className="column is-one-third">
            <div className="card">
              <div className="card-content">
                <p className="title is-5">Project 2</p>
                <p className="subtitle is-6">Description of the project.</p>
              </div>
            </div>
          </div>
          <div className="column is-one-third">
            <div className="card">
              <div className="card-content">
                <p className="title is-5">Project 3</p>
                <p className="subtitle is-6">Description of the project.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
